<div
  class="copy-to-clipboard"
  trackable
  [trackingObject]="trackingObject"
  [trackingAction]="trackingAction"
  [trackingAdditionalProperties]="trackingAdditionalProperties"
  (click)="copyContent()"
>
  <div class="content" [innerHTML]="value | safe: 'html'"></div>
</div>
<button class="copy-button" (click)="copyContent()">
  {{ copyLinkCta }}
</button>
